// extracted by mini-css-extract-plugin
export default {"container":"S6dq","adminsData":"DaDC"};